exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styled-checkbox-wrapper--checkbox .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #ed1849;\n  border-color: #000000;\n}\n.styled-checkbox-wrapper--checkbox .ant-checkbox-checked .ant-checkbox-inner::after {\n  border: 2px solid #000000;\n  border-top: 0;\n  border-left: 0;\n}\n", ""]);

